import React, { useState, useEffect, useContext} from "react";
import { Helmet } from "react-helmet";
import PageWrapper from "../components/PageWrapper";
import Icon from '@mui/material/Icon';
import HowItWorks from "../sections/home/HowItWorks"; 
import GlobalContext from "../context/GlobalContext"; 
import { HomeFeaturedList } from "../utils/GetAPIUtils"; 
import "../style/css/style.css";
import "../style/css/media.css";

import "../style/css/common.css";
import { useLocation } from 'react-router-dom';
export default function MainPage({ zone, navType }) {
    const gContext = useContext(GlobalContext);
    const [featuredData, setFeaturedData] = useState(null);
    const pathName = useLocation().pathname.toLowerCase();
    const hide = true;
    async function getHomeFeatureData() {
        try {
            
            const result = await HomeFeaturedList();

            if (result.data.homeFeaturedList.responseData.code == "200") {
             
                let data = JSON.parse(result.data.homeFeaturedList.responseData.message);
               
                setFeaturedData(data);
            }
           
        }
        catch (e) {

        }
    }
    useEffect(() => {
        document.title = "Compliance Project Managers Jobs | Syncuppro";
        const user = localStorage.getItem('connect');
        if (user==null && pathName.trim().toLowerCase() == "/login") {

            gContext.toggleSignInModal();
        } 
        if (user == null && pathName.trim().toLowerCase() == "/signup") {
            gContext.toggleSignUpModal();
        }
        if (user == null && (pathName.trim().toLowerCase() == "/signupsuccess" || pathName.trim().toLowerCase() == "/signupsuccess_expert" || pathName.trim().toLowerCase() == "/signupsuccess_client") && localStorage.getItem('userEmail')) {
            gContext.toggleSignUpModal();
        }
        
        if (user == null && localStorage.getItem('userEmail') && (pathName.trim().toLowerCase() == "/signupcode" || pathName.trim().toLowerCase() == "/signupcode_expert" || pathName.trim().toLowerCase() == "/signupcode_client")) {
            gContext.toggleSignUpModal();
        }
        else if (pathName.trim().toLowerCase() == "/signupcode") {
            window.location.href = "/";
        }
        if (window.location.href.split('#').length > 1)
            window.location.href = window.location.href.replace(window.location.origin, "");
       
        const passwordChanged = localStorage.getItem('passwordChanged');      
        if (passwordChanged) {
            localStorage.removeItem('passwordChanged'); 
            gContext.toggleSuccessModal();
        }
        getHomeFeatureData();

    }, [])

  return (
      <>  
      <Helmet>
          <title>Compliance Project Managers Jobs | Syncuppro</title>
          <meta property="og:title" content="Compliance Project Managers Jobs | Syncuppro" />
          <meta name="twitter:title" content="Compliance Project Managers Jobs | Syncuppro" />
          <meta name="description" content="Get top compliance manager jobs and skilled compliance project managers for your compliance projects. Expert support to drive success and meet regulations." />
          <meta name="og:description" content="Get top compliance manager jobs and skilled compliance project managers for your compliance projects. Expert support to drive success and meet regulations." />
          <meta name="twitter:description" content="Get top compliance manager jobs and skilled compliance project managers for your compliance projects. Expert support to drive success and meet regulations." />
          <meta name="keywords" content="compliance manager jobs, compliance projects, compliance project manager" />
      </Helmet>
      <PageWrapper
        headerConfig={{
                  bgClass: "dynamic-sticky-bg",
                  button: navType
        }}
          >
              <div className="page-wrapper">
 
              <section className="section welcome-sec bg-gray p-relative gradient-img bg-gray">
                      <div className="left-sec bg-gray text-center p-10 ">
                      <div className="section-title  m-10 p-10 text-center">

                              <h1> Compliance Projects Manager : Connect, Engage, and Grow.</h1>
                              <p className="section-desc p-10  p-l-50 p-r-50 ">Be part of the World Largest Compliance Marketplace - Your next project is a click away.</p>
                              <p className="section-desc p-10  p-l-50 p-r-50 ">Connect. Collaborate. Lead. Our platform empowers Compliance Experts, Compliance Managers, and Compliance Project Managers to find meaningful work and deliver results that matter.</p>
                              <div class="d-grid w-full   p-30  text-center">   {!localStorage.getItem('connect') && <button id="signup3" className="btn btn-green btn-block  w-150 m-auto  " type="button" onClick={(e) => {
                                  if (!localStorage.getItem('connect')) {
                                      e.preventDefault();
                                      gContext.setDefaultUserType("expert");
                                      gContext.toggleSignUpModal();
                                  }

                              }}>Sign up</button>}
                              </div>
                              <p className="section-desc p-10 p-l-50 p-r-50 ">Join a dedicated network of Compliance professionals. Access projects, build client relationships, and enhance your expertise with every project.</p>

                              
                      </div>                   

                       
                  </div>

                  <div className="right-sec">
                      <div className="img-wrapper">
                          <img className="img-block" src="images/workers-img.svg" alt="image" />
                      </div>
                  </div>
              </section>
            
              <HowItWorks defaultType="1" />
           
              <div className="m-20">&nbsp;</div>
                  <div className="m-20">&nbsp;</div>
              </div>
      </PageWrapper>
    </>
  );
};

